import _baseIsNative_default from "./_baseIsNative.js";
import _getValue_default from "./_getValue.js";

//#region ../../node_modules/lodash-es/_getNative.js
/**
* Gets the native function at `key` of `object`.
*
* @private
* @param {Object} object The object to query.
* @param {string} key The key of the method to get.
* @returns {*} Returns the function if it's native, else `undefined`.
*/
function getNative(object, key) {
	var value = _getValue_default(object, key);
	return _baseIsNative_default(value) ? value : void 0;
}
var _getNative_default = getNative;

//#endregion
export { _getNative_default as default };
//# sourceMappingURL=_getNative.js.map